export enum FLOW_FOOTER {
    PAYMENT= "PAYMENT",
    PRINT_TAG = "PRINTTAG",
}

export enum OPTIONS_MENU{
  PRINTING_BOARDING_PASS = 1,
  SELECTION_SEAT,
  SELECTION_BAGS,
  IS_VENEZUELA
}

export enum OPTION_MODAL_PASSPORT{
  WRITE_MANUAL_DATA,
  READ_SUCCESS,
}
